import React from 'react';
import { Icon, List, Progress } from 'antd';
import { connect } from 'react-redux';
import { updateProgress } from '../action_creators';
import conditionGroupValidation from '../Field/utils';

const sToP = (state) => ({
  active: state.active.section,
  project: state.project,
  sections: state.sections,
  fields: state.fields,
});

const isFieldVisible = (field, fields) => {
  // If no condition, default to visible
  if (!field || !field.conditionGroup || !field.conditionGroup.cgList || field.conditionGroup.cgList.length === 0) {
    return true;
  }

  // Use conditionGroupValidationFn to check visibility
  const { cgList, operand } = field.conditionGroup;
  return conditionGroupValidation(cgList, fields, operand);
};

export function ActiveSectionDisplay({ project = { intake: { order: [] } }, sections, active, fields }) {
  const orderedSections = project.intake.order.map((id) => sections[id]);

  // Helper function to determine if a field is answered
  const isFieldAnswered = (field, fields) => {
    if (
      field &&
      isFieldVisible(field, fields) &&
      field.type !== 'info-box' &&
      field.value
    ) {
      if (field.type === 'multiselect' || field.type === 'checkboxes') {
        return Object.keys(field.value.values).length > 0;
      }
      return true;
    }
    return false;
  };

  // Calculate total questions for each section
  const totalQuestions = orderedSections.reduce((total, section) => {
    return (
      total +
      section.order.filter(
        (fId) =>
          fields[fId] &&
          isFieldVisible(fields[fId], fields) &&
          fields[fId].type !== 'info-box'
      ).length
    );
  }, 0);

  // Calculate answered questions for each section
  const answeredQuestions = orderedSections.reduce((total, section) => {
    return (
      total +
      section.order.filter((fId) => isFieldAnswered(fields[fId], fields)).length
    );
  }, 0);

  const percentComplete = totalQuestions ? Math.round((answeredQuestions / totalQuestions) * 100) : 0;

 

  return (
    <div>
      <div style={{ padding: '1.5rem' }}>
        <Progress percent={percentComplete} strokeWidth={20} strokeColor='#234091' />
        <div className="progress-text" style={{ textAlign: 'center', fontWeight: 'bold' }}>
          {answeredQuestions}/{totalQuestions} Answered
        </div>
      </div>
      <div style={{ borderBottom: '0.1rem solid #DFE3E8', padding: '1.5rem' }}>
        <List
          itemLayout="vertical"
          dataSource={orderedSections}
          renderItem={(item) => {
            const sectionTotal = item.order.filter(
              (fId) =>
                fields[fId] &&
                isFieldVisible(fields[fId], fields) &&
                fields[fId].type !== 'info-box'
            ).length;
            const sectionAnswered = item.order.filter((fId) =>
              isFieldAnswered(fields[fId], fields)
            ).length;
            return (
              <List.Item style={{ border: 'none', margin: 0, padding: 0 }}>
                <div className="full-width flex-row align-center">
                  <div className="flex-row align-center justify-center" style={{ flex: 1 }}>
                    {sectionAnswered === sectionTotal ? (
                      <Icon theme="filled" style={{ color: 'green' }} type="check-circle" />
                    ) : (
                      <div
                        style={{
                          padding: '.75rem',
                          borderRadius: '1rem',
                          background: item.id === active ? '#234091' : '#C4CDD5',
                        }}
                      ></div>
                    )}
                  </div>
                  <div className="bold" style={{ flex: 5 }}>
                    {item ? `${item.title} (${sectionAnswered}/${sectionTotal})` : '[no section]'}
                  </div>
                  <div style={{ flex: 2 }}>{item ? item.status : 'Not Started'}</div>
                </div>
              </List.Item>
            );
          }}
        />
      </div>
    </div>
  );
}

const WrappedActiveSectionDisplay = connect(sToP, { updateProgress })(ActiveSectionDisplay);
export default WrappedActiveSectionDisplay;